<template>
  <div class="text-xs-center">
    <v-dialog :value="activate" width="60%" persistent>
      <v-card>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-icon color="error" @click="$emit('close')">$vuetify.icons.rms_close</v-icon>
        </v-toolbar>
        <v-layout wrap column pa-3>
          <v-flex xs12 md6 lg6 sm6>
            <v-text-field v-model="tag.name" :label="$t('rms.field.name.label')"></v-text-field>

            <v-select
              v-if="tag_type == DEFINES.TAG_TYPE.FOR_TERRITORIES"
              v-model="selected_countries"
              autocomplete
              :items="countries"
              item-text="name"
              item-value="id"
              label="Countries"
              multiple
            ></v-select>
            <v-layout row wrap align-center>
              <v-flex xs6 lg2 md2 justify-center>
                <span class="font-weight-medium">Publish</span>
              </v-flex>
              <v-flex xs6 lg10 md10>
                <v-checkbox v-model="tag.is_published"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outline flat @click="$emit('close')">{{$t('rms.button.cancel')}}</v-btn>
          <v-btn color="success" outline flat @click="save()">{{$t('rms.button.save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
export default {
  name: "AddTagDialog",
  props: ["activate", "tag_type", "countries"],
  data() {
    return {
      tag: {
        name: null,
        type: null,
        is_published: false
      },
      editing: false,
      create_action: "adminTag/create",
      update_action: "adminTag/update",
      selected_countries: ""
    };
  },

  methods: {
    async save() {
      try {
        var action = null;

        this.editing
          ? (action = this.update_action)
          : (action = this.create_action);
        if (this.tag_type == this.DEFINES.TAG_TYPE.FOR_TERRITORIES) {
          this.tag.selected_countries = this.selected_countries;
        }
        await this.$store.dispatch(action, this.tag);

        this.$store.dispatch("adminTag/list", {
          type: this.tag.type
        });

        this.$emit("close");

        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.tag_created"),
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    onAdd(tag_type) {
      this.editing = false;
      this.selected_countries = "";
      //replace tag for new tag
      this.tag = {
        name: null,
        type: tag_type,
        is_published: false
      };
    },

    onEdit(tag) {
      this.editing = true;
      //replace tag with editable data
      this.tag = tag;
      if (this.tag_type == this.DEFINES.TAG_TYPE.FOR_TERRITORIES) {
        this.selected_countries = tag.countries;
      }
    }
  }
};
</script>
